import {array, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';
import {KYC_STATUSES} from '../types';

export const kycRecordV8nSchema = object().shape({
  account_id: string().required(),
  provider: string().required(),
  registered_at: string().required(),
  country: string().required(),
  status: string().oneOf(KYC_STATUSES).required(),
  decline_reason: stringOptionalNullable,
});

export const v8nSchemaOfGetKycResponse = paginationV8nSchema.shape({
  array: array().of(kycRecordV8nSchema).required(),
});
